<template>
    <b-button :class="{...{'choice-button':true},...button._custom_class}" :disabled="block_form" @click="nextStep()">
        <img v-if="!button._custom_class && button._icon" :src="button._icon" class="choice-icon">
        <span class="choice-display">{{button._display}}</span>
        <div v-if="!button._custom_class">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 16">
                <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <path d="M8.3 1.5L14 8.2l-5.7 6.3M13.2 8H1"/>
                </g>
            </svg>
        </div>
    </b-button>
</template>

<script>
import { get } from 'vuex-pathify'
export default {
    props: ['button','step'],
    computed: {
        loading: get('func_data/loading'),
        block_form: get('func_data/block_form')
    },
    methods: {
        nextStep(){
            // Set Value
            if(this.step._field_name){
                this.$store.set('form_data/'+this.step._field_name,this.button._value)
            }

            // Set Other Data
            if(!_.isEmpty(this.button._other_datas_to_set)){
                _.forEach(this.button._other_datas_to_set, (other_data)=>{
                    this.$store.set(other_data.path+ '/' + other_data.name, other_data.value)
                })
            }

            this.$store.dispatch('form/goToNextStep', this.button)
            // Next Route
        }

    }
}
</script>
